import _ from 'lodash';
import React from 'react';
import { navigateAction } from 'fluxible-router';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import InventoryRecordStore, { defaultSorter } from '../../stores/InventoryRecordStore';
import Helmet from 'react-helmet';
import Breadcrumbs from '../../components/Breadcrumbs';
import { trackSearchEvent } from '../../components/InventorySearch';
import InventorySearchResults from '../../components/InventorySearchResults';
import styles from './index.sass';

class InventorySearchContainer extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func,
    trackEvent: React.PropTypes.func,
    buildURLForRoute: React.PropTypes.func
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  getHelmetProps(store) {
    let description = store.metaTagDescription();
    let title = store.metaTagTitle();
    return {
      title: title,
      meta: [
        {name: 'description', content: description},
        {property: 'og:title', content: title},
        {property: 'og:description', content: description},
        {property: 'og:url', content: this.props.currentRoute.absolute_url},
        {name: 'twitter:title', content: title},
        {name: 'twitter:description', content: description}
      ]
    };
  }

  handleOnClickBreadcrumbsFilter(filter) {
    // Remove it
    let filters = _.filter(this.props.inventorySearchState.filters, (f) => {
      return !_.isEqual(f, filter);
    });
    let sorter = this.props.inventorySearchState.sorter;
    if(!sorter || _.isEqual(sorter, defaultSorter)) {
      sorter = null;
    }

    trackSearchEvent(this.context, {
      filters: filters,
      pagination: this.props.inventorySearchState.pagination,
      sorter: sorter,
      uiMethod: 'delete_token'
    });

    this.context.executeAction(navigateAction, {
      url: this.context.buildURLForRoute('search', {
        filters: filters,
        sorter: sorter
      })
    });
  }

  render() {
    let { store, inventorySearchState, shoppingCart, currentRoute } = this.props;
    let inventorySearchResultsProps = {
      currentRoute,
      store,
      ...inventorySearchState,
      loading: inventorySearchState.loading //|| !this.props.isNavigateComplete
    };
    let breadcrumbHelperText = null;
    let searchResultCount = inventorySearchState.pagination && inventorySearchState.pagination.hasOwnProperty('totalResults') ? inventorySearchState.pagination.totalResults : null;
    if(searchResultCount !== null) {
      if(!searchResultCount) {
        breadcrumbHelperText = 'No results';
      } else if(searchResultCount === 1) {
        breadcrumbHelperText = '1 result';
      } else {
        breadcrumbHelperText = `${searchResultCount} results`;
      }
    }
    let breadcrumbsProps = {
      className: styles.breadcrumbs,
      links: [
        {routeName: 'storeLandingPage'},
        {routeName: 'search'}
      ],
      helperText: breadcrumbHelperText,
      onClickFilter: this.handleOnClickBreadcrumbsFilter.bind(this)
    };

    if(inventorySearchState.filters.length) {
      breadcrumbsProps.filters = _.filter(inventorySearchState.filters, (filter) => {
        switch(filter.type) {
          case 'text':
          case 'min_price_in_cents':
          case 'max_price_in_cents':
          case 'store_id':
            return false;
          default:
            return true;
        }
      });
    }

    return (
      <section className={styles.container}>
        <Helmet {...this.getHelmetProps(store)} />
        <Breadcrumbs {...breadcrumbsProps} />
        <InventorySearchResults {...inventorySearchResultsProps} />
      </section>
    );
  }
}

InventorySearchContainer = connectToStores(InventorySearchContainer, [InventoryRecordStore], (context, props) => {
  return {
    inventorySearchState: context.getStore(InventoryRecordStore).getCurrentSearchState()
  };
});

export default InventorySearchContainer;



// WEBPACK FOOTER //
// banquet/containers/InventorySearchContainer/index.js